import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IAdminCommunityRO } from 'api'
import dayjs from 'dayjs'
import parse from 'html-react-parser'
import { useNavigate } from 'react-router-dom'

export default function NoticeEdit() {
  const id = useQueryValue('id', 0)
  const slug = useQueryValue('slug', '')
  const navigate = useNavigate()

  const { data } = useApi({
    id: 'communityDetail',
    fn: api().adminCommunity.getCommunityArticleDetail,
    params: id,
    enabled: !!id,
  })

  const onSave = async (data: IAdminCommunityRO) => {
    if (id) {
      await api().adminCommunity.updateCommunityNotice(id, {
        title: data.title,
        content: data.content,
        articleStatus: data.articleStatus,
      })
    } else {
      await api().adminCommunity.createCommunityNotice({
        title: data.title,
        content: data.content,
        articleStatus: data.articleStatus,
      })
    }

    navigate('/notice')
  }

  const onDelete = async () => {
    await api().adminCommunity.deleteCommunityArticle(id)
  }

  return (
    <ContentDetailView
      title="커뮤니티 상세"
      data={data}
      onDelete={id ? onDelete : undefined}
      onSave={onSave}
    >
      <DetailForm
        data={data}
        fields={[
          {
            key: 'title',
            label: '제목',
            type: FormFieldType.STRING,
            required: true,
          },
          {
            key: 'content',
            label: '상세내용',
            type: FormFieldType.CKEDITOR,
            required: true,
          },
          {
            key: 'createDate',
            label: '작성일',
            type: FormFieldType.STRING,
            readOnly: true,
            resolver: (data) => dayjs(data.createDate).format('YYYY-MM-DD'),
          },
          {
            key: 'articleStatus',
            label: '상태',
            type: FormFieldType.SELECT,
            required: true,
            options: [
              { label: '노출중', value: 'VISIBLE' },
              { label: '비노출', value: 'HIDDEN' },
            ],
          },
        ]}
      />
    </ContentDetailView>
  )
}
